import { createAction } from '@reduxjs/toolkit';

import type { ReadonlyAnnouncement } from 'js/src/data/announcements/announcement-types';
import { ANNOUNCEMENT_ACTIONS } from 'js/src/data/announcements/announcement-types';

export const storeAnnouncements = createAction<{
    announcements: readonly ReadonlyAnnouncement[];
}>(ANNOUNCEMENT_ACTIONS.STORE_ANNOUNCEMENTS);

export const setLoadingAnnouncements = createAction<{
    isLoading: boolean;
}>(ANNOUNCEMENT_ACTIONS.SET_LOADING_ANNOUNCEMENTS);

export const setAnnouncementsUnreadCount = createAction<{
    count: number;
}>(ANNOUNCEMENT_ACTIONS.SET_ANNOUNCEMENTS_UNREAD_COUNT);

export const markAnnouncementViewed = createAction<{
    announcementId: number;
}>(ANNOUNCEMENT_ACTIONS.MARK_ANNOUNCEMENT_VIEWED);
